import { intervalToDuration } from 'date-fns';

const getDurationTime = (seconds: number) => {
  const duration = intervalToDuration({ start: 0, end: seconds * 1000 });
  const parts = [];

  if (duration.days && duration.days > 0) parts.push(`${duration.days}d`);
  if (duration.hours && duration.hours > 0) parts.push(`${duration.hours}h`);
  if (duration.minutes && duration.minutes > 0) parts.push(`${duration.minutes}min`);
  parts.push(`${duration.seconds || 0}s`);

  return parts.join(' ');
};

export default getDurationTime;
